import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const customerManagementRoutes = {
  name: 'customer-management',
  path: 'customer-management',
  component: () => import('./CustomerManagement.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
